import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import GAListener from "./analytics/GAListener";



// ✅ Firebase bits
import { onAuthStateChanged } from "firebase/auth";
import {
  auth,
  ensureUserDoc,
  ensureSchoolIdForCurrentUser, // <- ensures/creates a schools/{id} + stamps users/{uid}.schoolId
} from "./firebase";

/**
 * Small boot component:
 * - waits for Firebase auth
 * - ensures users/{uid} exists
 * - if user looks like a school purchaser/admin, ensures a schools/{id} exists,
 *   stamps users/{uid}.schoolId, and caches localStorage.schoolId
 */
function AuthBootstrap() {
  useEffect(() => {
    const off = onAuthStateChanged(auth, async (u) => {
      if (!u) return;

      try {
        // Make sure we at least have the base user doc
        await ensureUserDoc();

        // Try to resolve/create a school and cache it (if applicable)
        const sid = await ensureSchoolIdForCurrentUser();
        if (sid) {
          try {
            localStorage.setItem("schoolId", sid);
          } catch {
            /* ignore */
          }
        }
      } catch (e) {
        // Don't break the app if bootstrap fails; dashboards can still attempt again
        console.warn("[bootstrap] auth init failed:", e?.message || e);
      }
    });
    return () => off();
  }, []);

  return null; // purely side-effects
}

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <Router>
    {/* ✅ GA4 SPA route tracking */}
    <GAListener />
    {/* 🔧 Runs once, sets up user doc + schoolId if needed */}
    <AuthBootstrap />
    <App />
  </Router>
);


serviceWorkerRegistration.register();



